// extracted by mini-css-extract-plugin
export default {"elementCornerSquare":"ElementCornerSquares_elementCornerSquare__BNGBO"};